import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { sceneTint } from './SceneCard.js';
import type { Scene } from './storyboardResult.js';

export function SceneTimeline({ scenes }: { scenes: Scene[] }): ReactNode {
  return (
    <Box sx={{ overflowX: 'auto', flexShrink: 0 }}>
      <Stack
        direction="row"
        aria-label="Scene timeline"
        sx={{ gap: '6px', minWidth: scenes.length * 100 }}
      >
        {scenes.map((scene, index) => (
          <Stack
            key={`${scene.shot_label}-${scene.start_seconds}-${scene.visual}`}
            sx={{
              gap: '4px',
              flex: Math.max(1, (scene.end_seconds ?? 0) - (scene.start_seconds ?? 0)),
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                bgcolor: sceneTint(index),
                p: '8px 6px',
                borderRadius: '6px',
                fontSize: 10,
              }}
            >
              {scene.objective || scene.shot_label}
              {scene.start_seconds === null || scene.end_seconds === null
                ? ''
                : ` (${scene.end_seconds - scene.start_seconds}s)`}
            </Box>
            <Typography
              sx={{
                fontSize: 10,
                color: 'text.secondary',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {scene.start_seconds === null ? 'Static frame' : `${scene.start_seconds}s`}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
